import { Component, Input, OnInit, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
// import { Router } from '@angular/router';

import { ee } from '../constants';
import { MenuItem } from '../types';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false
})
export class SidebarComponent implements OnInit {
  auth = inject(AuthService);

  @Input() items: [ ...MenuItem ];
  @Input() current: string;

  ngOnInit() {
    // Show items without permissions or those items the user has permission to see
    this.items = this.items.filter(item =>
      !item.permission || (item.permission && this.auth.currentUser.permissions?.includes(item.permission))
    );
  }

  changeContent(content: string): void {
    ee.emit('changeContent', content);
  }

  /* navigate(link: string): void {
    this.router.navigate([link]);
  } */

}
